export enum UserRoleEnum {
  SUPERADMIN = "SUPERADMIN",
  ADMIN = "ADMIN",
  TEACHER = "TEACHER",
  STUDENT = "STUDENT", // Student role might not be required here in front end.
  USER = "USER", // User are usually parents or guardians.
}

// user this is used to trsanform the user role in the front end.
export const UserRole = {
  SUPERADMIN: "Super admin",
  ADMIN: "Admin",
  TEACHER: "Teacher",
  STUDENT: "Student",
  USER: "User",
};
